import ServiceBase from '@/services/ServiceBase';

const resource = 'api/v1/area';

class AreaService extends ServiceBase {
  constructor() {
    super({ resource });
  }
}

export default AreaService;



// WEBPACK FOOTER //
// ./src/services/AreaService.js